/**
 * @fileoverview `formatCountdown` — the ONE countdown clock a throttled form shows.
 * @package @puffin-core/form-security
 *
 * The countdown is a CLOCK (`0:45`, `14:59`), not "N seconds": it reads correctly at every length a policy
 * can set, and it needs no plural form, which the English degrade path cannot select.
 *
 * Its own DOM-free module (it lived inside `RateLimitNotice.jsx`) so the web `<RateLimitNotice>` and
 * palm-native's native notice read the same clock through `@puffin-core/form-security/core`
 * (LIFE-SHORTLISTED-001 D13, 2026-10-13).
 *
 * @module @puffin-core/form-security/formatCountdown
 */

/**
 * Format a remaining wait as a clock: `m:ss` under an hour, `h:mm:ss` from an hour up.
 *
 * Rounded UP to the whole second, so the clock never reads `0:00` while the form is still locked.
 *
 * @param {number} ms - milliseconds remaining
 * @returns {string} the clock text
 */
export function formatCountdown(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, '0')}:${seconds}`
    : `${minutes}:${seconds}`;
}

export default formatCountdown;
